import ContextMenu from "../../../Basic/Elements/ContextMenu";

const ProviderProductsContextMenu = ({
  removeProducts = (_) => _,
  UnarchiveProducts = (_) => _,
  archiveProducts = (_) => _,
  stopbrandProducts = (_) => _,
  UnstopbrandProducts = (_) => _,
  MarkProducts = (_) => _,
  UnmarkProducts = (_) => _,
  isArchive = false,
  isStopbrand = false,
  ...props
}) => {
  return (
    <ContextMenu
      list={[
        { text: 'Удалить товары', callback: () => removeProducts() },
        { text: 'Перенести в архив', callback: () => archiveProducts(), isHidden: isArchive || isStopbrand },
        { text: 'Перенести в стоп бренды', callback: () => stopbrandProducts(), isHidden: isArchive || isStopbrand },

        { text: 'Убрать с архива', callback: () => UnarchiveProducts(), isHidden: !isArchive },
        { text: 'Убрать с стоп бренды', callback: () => UnstopbrandProducts(), isHidden: !isStopbrand },
        { text: 'Маркированный товар ЧЗ', callback: () => MarkProducts() },
        { text: 'Убрать маркировку ЧЗ', callback: () => UnmarkProducts() },
      ]}
      {...props}
    >
      Действия
    </ContextMenu>
  );
};

export default ProviderProductsContextMenu;
